
{
  "fr": {
    "zendesk_button": {
      "label": "Chat"
    }
  }
}
